import { render } from "./StaticTable.vue?vue&type=template&id=e859cfb8&scoped=true&ts=true"
import script from "./StaticTable.vue?vue&type=script&lang=ts"
export * from "./StaticTable.vue?vue&type=script&lang=ts"

import "./StaticTable.vue?vue&type=style&index=0&id=e859cfb8&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e859cfb8"]])

export default __exports__